module.exports = __webpack_public_path__ + "images/help/icon-twr46-d9b6c36ab1f07a9f76bf0613ea0370a0.png";